import React from "react";

import PieChartWithPaddingAngle from "./PieChartWithPaddingAngle";
import SimpleRadarChart from "./SimpleRadarChart";
import StackedBarChart from "./StackedBarChart";
import TinyLineChart from "./TinyLineChart";
import TwoLevelPieChart from "./TwoLevelPieChart";
import ComposedChart from "./ComposedChart";
import FunnelChart from "./FunnelChart";

export const DEFAULT_COLORS = ["#00b8a9", "#7471CA", "#FC427B", "#74b9ff"];
export const ORIENTATION_V = "vertical";
export const ORIENTATION_H = "horizontal";
export const ORIENTATIONS = [ORIENTATION_V, ORIENTATION_H];

const resolveChart = (props) => ({
  TwoLevelPieChart: <TwoLevelPieChart {...props} />,
  PieChartWithPaddingAngle: <PieChartWithPaddingAngle {...props} />,
  StackedBarChart: <StackedBarChart {...props} />,
  SimpleRadarChart: <SimpleRadarChart {...props} />,
  TinyLineChart: <TinyLineChart {...props} />,
  ComposedChart: <ComposedChart {...props} />,
  FunnelChart: <FunnelChart {...props} />,
});

function ChartResolver({ type, data, colors, ...other }) {
  return (
    <>
      {
        resolveChart({
          data,
          colors: colors || DEFAULT_COLORS,
          ...other,
        })[type]
      }
    </>
  );
}

export default ChartResolver;
